
















import UICard from '@sbvr/ui/UICard.vue';
import { createComponent } from '@vue/composition-api';

export default createComponent({
  name: 'ContentCard',
  components: {
    UICard,
  },
  props: {
    routerLink: {},
    content: {
      required: true,
      // validator (val) {
      //   return val.__typename === 'ContentOwnership' || val.__typename === 'Game';
      // },
    },
    badges: {
      type: Array,
    },
  },
});
